import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const closeSpan = styled.span`
  border-radius: 100%;
  background-color: #dcdcdc;
  height: 45px;
  width: 45px;
  padding-top: 4px;
  padding-left: 12px;
  font-size: 30px;
  margin-left: auto;
`;

export const radioInput = styled.input`
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: #2196f3;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`;

export const Main = styled.div`
  display: flex;

  .divClass {
    padding: 25px;

    display: flex;
    flex-direction: column;
    row-gap: 3rem;
  }
  ul {
    list-style-type: none;
    margin-left: 0;

    max-height: 180px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  ul li {
    margin-bottom: 12px;
    margin-left: 5px;
    display: flex;
    align-items: center;
  }
  ul li.legend::before {
    color: transparent;
    font-size: 1px;
    border-radius: 100%;
    content: " ";
    margin-left: -1.3em;
    margin-right: 15px;
    padding: 10px;
    background-color: orange;
    -webkit-mask-size: cover;
  }
  ul li.legend:last-child::before {
    color: transparent;
    font-size: 1px;
    border-radius: 100%;
    content: " ";
    margin-left: -1.3em;
    margin-right: 15px;
    padding: 10px;
    background-color: blue;
    -webkit-mask-size: cover;
  }
`;

export const SideBar = styled.div`
  & .clearFilter {
    background-color: transparent;
    color: ${theme.colors.primaryBlue};

    &:hover {
      cursor: pointer;
    }
  }
`;

export const Title = styled.h3`
  font-weight: 700;
  display: block;
  font-size: 1.3rem;
`;

export const SubTitle = styled.h4`
  font-weight: 700;
  display: block;
  font-size: 1rem;
  margin-top: 1rem;
`;

export const LineCustom = styled.span`
  display: block;
  border-bottom: 1px solid #dee1db;
  height: 0;
  margin: 1rem 0;
`;

export const CalendarContainer = styled.div`
  width: 100%;
  padding: 1rem;

  & .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;
    font-family: inherit;

    border-radius: 0;
    width: 100%;

    & .vc-day-layer .vc-highlight {
      width: 100%;
      height: 100%;
      border-radius: 0 !important;
      opacity: 0.5;
    }

    & .itemContainer {
      display: flex;
      flex-direction: column;
      z-index: 10;
      height: 100%;
      overflow: hidden;

      & .dayItem {
        color: ${theme.colors.black};
        font-size: 1rem;
      }

      & .contentItem {
        flex-grow: 1;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 0;
        }

        & .text {
          font-size: 0.75rem;
          padding: 0.25rem;
          margin-top: 0;
          margin-bottom: 0.25rem;
          line-height: 1.25;
          border-radius: 0.25rem;

          &.blue {
            background-color: blue;
            color: white;
          }

          &.orange {
            background-color: orange;
          }
          &.black {
            background-color: black;
            color: white;
          }
          &.red {
            background-color: red;
            color: white;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    & .vc-header {
      background-color: #f1f5f8;
      padding: 10px 0;
    }
    & .vc-weeks {
      padding: 0;
    }
    & .vc-weekday {
      background-color: var(--weekday-bg);
      border-bottom: var(--weekday-border);
      border-top: var(--weekday-border);
      padding: 5px 0;
    }
    & .vc-day {
      padding: 0 5px 3px 5px;
      text-align: left;
      height: var(--day-height);
      min-width: var(--day-width);
      background-color: white;

      /* .active &.weekday-1,
      &.weekday-7 {
        background-color: #eff8ff;
      } */

      &:not(.on-bottom) {
        border-bottom: var(--day-border);
        &.weekday-1 {
          border-bottom: var(--day-border-highlight);
        }
      }
      &:not(.on-right) {
        border-right: var(--day-border);
      }
    }
    & .vc-day-dots {
      margin-bottom: 5px;
    }
  }
`;
